import React from "react";
import { Badge, CopyButton, Table } from "@opendate-app/setlist";

const styles = {
  copyCell: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: 0,
    minWidth: "100%",
  },
  value: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: 13,
    color: "var(--sl-text-primary)",
  },
};

const CopyCell = ({ value, name, copyable = true }) => (
  <div style={styles.copyCell}>
    <span style={copyable ? styles.value : { ...styles.value, whiteSpace: "normal" }} title={value}>{value}</span>
    {value && copyable ? <CopyButton value={value} label={null} size="sm" aria-label={`Copy ${name}`} /> : null}
  </div>
);

const DnsRecordsTable = ({ records }) => {
  const columns = [
    records.some((record) => record.purpose) && { key: "purpose", header: "Purpose", primary: true },
    { key: "type", header: "Record type", render: (record) => record.type?.toUpperCase() },
    { key: "host", header: "Host", width: "35%", render: (record) => <CopyCell value={record.host} name={`${record.type?.toUpperCase()} host for ${record.host}`} /> },
    { key: "data", header: "Data", width: "35%", render: (record) => <CopyCell value={record.data} name={`${record.type?.toUpperCase()} data for ${record.host}`} copyable={record.copyable !== false} /> },
    records.some((record) => record.verified !== undefined) && {
      key: "verified",
      header: "Status",
      render: (record) => (
        <Badge color={record.verified ? "success" : "gray"} dot>{record.verified ? "Verified" : "Not found"}</Badge>
      ),
    },
  ].filter(Boolean);

  return (
    <Table
      columns={columns}
      data={records}
      getRowKey={(record) => record.key}
      stackBelow={720}
    />
  );
};

export default DnsRecordsTable;
